import React from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'
import { ISchoolLevel } from '../props/SchoolProp'

const StyledLevelBadge = styled.div`
  display: inline-block;
  border-radius: ${STYLES.BORDER_RADIUS};
  overflow: hidden;
  margin: ${STYLES.BADGE_MARGIN};
  line-height: ${STYLES.BADGE_LINE_HEIGHT};
`

const BadgeSelector = styled.div`
  font-size: ${STYLES.FONT_SIZE_SM};
  display: inline-block;
  padding: ${STYLES.BADGE_CONTENT_PADDING};
  ${({ isSupport }: { isSupport: boolean }) =>
    isSupport
      ? `
    background-color: #bbd9e8;
    color: ${STYLES.COLOR_BLACK};
    font-weight: bold;
  `
      : `
    background-color: ${STYLES.COLOR_ATHENS_GRAY};
    color: ${STYLES.COLOR_HIT_GRAY}
  `}
`

interface ILevelBadgeProps {
  className?: string
  children: ISchoolLevel
}

const LevelBadge: React.FC<ILevelBadgeProps> = ({ children, className }) => (
  <StyledLevelBadge className={className}>
    <BadgeSelector isSupport={children?.elc}>ELC</BadgeSelector>
    <BadgeSelector isSupport={children?.kinder}>Kinder</BadgeSelector>
    <BadgeSelector isSupport={children?.primary}>Primary</BadgeSelector>
    <BadgeSelector isSupport={children?.secondary}>Secondary</BadgeSelector>
  </StyledLevelBadge>
)

export { LevelBadge }
